import React, { useState, useContext } from "react";
import { ThemeContext } from "../context/themeContext";
import LoginForm from "./LoginForm";
import SignupForm from "./SignupForm";
import ForgotPasswordForm from "./ForgotPasswordForm";
import VerifyCodeForm from "./VerifyCodeForm";
import ResetPasswordForm from "./ResetPasswordForm";

const LandingPage = () => {
  const { theme } = useContext(ThemeContext);
  const [currentForm, setCurrentForm] = useState("signup");
  const [userEmail, setUserEmail] = useState("");

  
  const renderForm = () => {
    switch (currentForm) {
      case "login":
        return (
          <LoginForm
            onForgotPassword={() => setCurrentForm("forgot")}
            onSignup={() => setCurrentForm("signup")}
          />
        );
      case "signup":
        return (
          <SignupForm
            onLogin={() => setCurrentForm("login")}
            userEmail={userEmail}
          />
        );
      case "forgot":
        return (
          <ForgotPasswordForm
            onBack={() => setCurrentForm("login")}
            onVerify={() => setCurrentForm("verify")}
            setUserEmail={setUserEmail}
          />
        );
      case "verify":
        return (
          <VerifyCodeForm
            onBack={() => setCurrentForm("forgot")}
            onReset={() => setCurrentForm("reset")}
          />
        );
      case "reset":
        return (
          <ResetPasswordForm
            onBack={() => setCurrentForm("verify")}
            onComplete={() => setCurrentForm("login")}
          />
        );
      default:
        return <LoginForm />;
    }
  };

  return (
    <div className={`${theme === 'dark' || theme === 'dim' ? 'dark' : ''} ${theme === 'dim' ? 'dim' : ''}`}>
  <div
    className="relative min-h-screen flex items-center justify-center overflow-hidden"
    style={{
      backgroundImage:
        "url('https://res.cloudinary.com/diml8ljwa/image/upload/v1761872629/hero_illustration_ppefew.png')",
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundAttachment: "fixed",
    }}
  >
    {/* Overlay */}
    <div className="absolute inset-0 bg-black/50" />

    {/* Auth Card */}
    <div
      className="
        relative z-10 bg-white dark:bg-black
        w-full h-screen sm:h-auto
        sm:w-[540px] md:w-[580px] lg:w-[620px]
        sm:rounded-[40px] sm:shadow-2xl
        px-[clamp(1rem,3vw,2.5rem)]
        py-[clamp(1.5rem,4vh,3rem)]
        flex flex-col justify-between
        transition-all duration-300 ease-in-out
        my-0 sm:my-[clamp(1rem,4vh,3rem)]
      "
    >
      {/* Back Icon — only show when not in forgot/reset/verify */}
      {/* {!["forgot", "verify", "reset"].includes(currentForm) && (
        <button
          onClick={() => (window.location.href = "https://paymeo.co")}
          className="absolute top-6 left-5 flex items-center gap-1 text-gray-600 hover:text-blue-600 transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
          <span className="hidden sm:inline text-sm">Back</span>
        </button>
      )} */}

      {/* Centered Content */}
      <div className="flex flex-col flex-1 justify-center items-center w-full">
        {/* Logo + Header — hidden on forgot/reset/verify */}
        {!["forgot", "verify", "reset"].includes(currentForm) && (
          <>
            {/* Logo */}
            {/* <div className="flex justify-center mb-4 sm:mb-5">
              <img
                src="/assets/favicon.png"
                alt="Paymeo Logo"
                className="w-[clamp(40px,8vw,64px)] h-[clamp(40px,8vw,64px)]"
              />
            </div> */}

            {/* Header */}
            {/* <div className="text-center w-full px-4 sm:px-0 mb-4 sm:mb-6">
              <h2 className="font-semibold text-gray-900 leading-snug text-[clamp(1.1rem,2.5vw,1.6rem)] mb-1">
                Grow your business with{" "}
                <span className="text-[#1e5aff]">Paymeo</span>
              </h2>
            </div> */}
          </>
        )}

        {/* Form */}
        <div className="w-full max-w-md flex justify-center items-center">
          {renderForm()}
        </div>
      </div>

      {/* Footer (Terms) */}
      <div className="text-center text-gray-500 leading-snug text-[clamp(0.75rem,1.5vw,0.9rem)] mt-4 sm:mt-6 mb-2 sm:mb-4">
        <p className="max-w-sm mx-auto">
          By continuing, you agree to our{" "}
          <a href="/terms" className="text-blue-600 hover:underline transition-colors">
            Terms of Service
          </a>{" "}
          and{" "}
          <a href="/terms#privacy" className="text-blue-600 hover:underline transition-colors">
            Privacy Policy
          </a>
          .
        </p>
      </div>
    </div>

    {/* Responsive tweaks */}
    <style>{`
      @media (max-width: 768px) {
        .sm\\:rounded-2xl {
          border-radius: 0 !important;
        }
        .sm\\:shadow-2xl {
          box-shadow: none !important;
        }
        html, body {
          height: 100%;
          overflow: hidden;
        }
        div[style*="background-attachment: fixed"] {
          background-attachment: scroll !important;
        }
        .flex-1 {
          justify-content: center !important;
          padding-top: 0 !important;
          padding-bottom: 0 !important;
        }
      }
    `}</style>
    </div>
    </div>
  );

};

export default LandingPage;
